import { DonorStatus, PermissionsEnum } from 'gql/types';
import { ControlledSelect } from 'modules/common/components';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getDonorStatuesOptions } from './options';

type CustomProps = {
  exclude?: DonorStatus[];
};
type PropTypes = Omit<ComponentProps<typeof ControlledSelect>, 'options'> &
  CustomProps;

const DonorStatusSelect: FC<PropTypes> = (props) => {
  const currentUser = useCurrentUser();
  const { t } = useTranslation('donor.DonorStatusSelect');
  const archiveDonorAllowed = currentUser.isCan(PermissionsEnum.ArchiveDonors);
  const exclude = [
    ...(props.exclude ?? []),
    ...(!archiveDonorAllowed ? [DonorStatus.Archived] : []),
  ];
  const donorStatusesOptions = getDonorStatuesOptions({ exclude });

  return (
    <ControlledSelect
      options={donorStatusesOptions}
      placeholder={t('selectStatus')}
      {...props}
    />
  );
};

export default DonorStatusSelect;
